@if (surface === 'Chem NI / AU') {
  <span class="label label-gold"
    ngbTooltip="Chem. Ni/Au"
    [ngClass]="{'label-big': size === 'big'}"
    >
    @switch (size) {
      @case ('big') {
        Gold
      }
      @case ('small') {
        G
      }
    }
  </span>
}
@if (empb) {
  <span class="label label-primary"
    ngbTooltip="Erstauftrag"
    [ngClass]="{'label-big': size === 'big'}"
    >
    @switch (size) {
      @case ('big') {
        EMPB
      }
      @case ('small') {
        E
      }
    }
  </span>
}
@if (kanban) {
  <span class="label label-purple"
    ngbTooltip="Kanban"
    [ngClass]="{'label-big': size === 'big'}"
    >
    @switch (size) {
      @case ('big') {
        KANBAN
      }
      @case ('small') {
        K
      }
    }
  </span>
}
@if (hasPlugging) {
  <span class="label label-rose"
    ngbTooltip="Viafill"
    [ngClass]="{'label-big': size === 'big'}"
    >
    @switch (size) {
      @case ('big') {
        VIAFILL
      }
      @case ('small') {
        VF
      }
    }
  </span>
}
@if (hasCopperFilling) {
  <span class="label label-orange"
    ngbTooltip="Copperfilling"
    [ngClass]="{'label-big': size === 'big'}"
    >
    @switch (size) {
      @case ('big') {
        COPPERFILLING
      }
      @case ('small') {
        C
      }
    }
  </span>
}
@if (hasBlindHole) {
  <span class="label label-info"
    ngbTooltip="Blind Via / Sackloch"
    [ngClass]="{'label-big': size === 'big'}"
    >
    @switch (size) {
      @case ('big') {
        Sackloch
      }
      @case ('small') {
        S
      }
    }
  </span>
}
@if (hasReproduction && !willBeMerged) {
  <span class="label label-danger"
    ngbTooltip="Nachfertigung"
    [ngClass]="{'label-big': size === 'big'}"
    >
    @switch (size) {
      @case ('big') {
        NACHFERTIGUNG
      }
      @case ('small') {
        NF
      }
    }
  </span>
}
@if (willBeMerged) {
  <span class="label label-danger"
    ngbTooltip="Zusammengeführte Nachfertigung"
    [ngClass]="{'label-big': size === 'big'}"
    >
    @switch (size) {
      @case ('big') {
        Zusammengeführte NACHFERTIGUNG
      }
      @case ('small') {
        ZNF
      }
    }
  </span>
}
@if (isT3) {
  <span class="label label-success"
    ngbTooltip="Plugged Via Typ IIIa"
    [ngClass]="{'label-big': size === 'big'}"
    >
    @switch (size) {
      @case ('big') {
        Plugged Via Typ IIIa
      }
      @case ('small') {
        T3
      }
    }
  </span>
}
@if (isT6) {
  <span class="label label-gold"
    ngbTooltip="Filled and Covered Typ VI Lack"
    [ngClass]="{'label-big': size === 'big'}"
    >
    @switch (size) {
      @case ('big') {
        Filled and Covered Typ VI Lack
      }
      @case ('small') {
        T6
      }
    }
  </span>
}
